import {useState} from 'react';

import AnimatedMediaBackground from '@/components/AnimatedMediaBackground/AnimatedMediaBackground';
import BackButton from '@/components/BackButton/BackButton';
import type {TipsInstruction, TipsItem} from '@/services/content/tipsContent.types';
import type {ImageModel, VideoModel} from '@/types/content';

import DetailView from './DetailView';

type PopupPageViewProps = {
    card: TipsItem;
    onBack: () => void;
};

const PopupPageView = ({card, onBack}: PopupPageViewProps) => {
    const instructions = card.instructions ?? [];
    const sortedInstructions = [...instructions].sort((a, b) => a.order - b.order);
    const firstInstruction = sortedInstructions[0] ?? null;
    const [currentInstruction, setCurrentInstruction] = useState<TipsInstruction | null>(firstInstruction);

    const video = currentInstruction?.video as VideoModel | undefined;
    const images = (currentInstruction?.images ?? card.images) as ImageModel[] | undefined;

    return (
        <div className='relative flex min-h-full w-full flex-col overflow-hidden bg-black text-white'>
            <AnimatedMediaBackground isPopupOpen isStatic mainImage={images} video={video} />

            <BackButton onClick={onBack} className='absolute top-safe-offset-4 left-4 z-50' />

            <div className='relative z-10 flex w-full flex-1 flex-col justify-end'>
                {instructions.length > 0 && (
                    <DetailView
                        instructions={instructions}
                        guideItemType={card.guideItemType}
                        onInstructionChange={setCurrentInstruction}
                    />
                )}
            </div>
        </div>
    );
};

export default PopupPageView;
